import { Countries } from '../confirmation-dialog/enumerations/countries';

export function countryDisplayWith(option: Countries): string {
   return `${option ?? ''}`;
}

export function countrySearch(searchText: string): Countries[] {
   return Object.values(Countries).filter((country) => country.toUpperCase().includes(searchText.toUpperCase()));
}

export function getCountries(): Countries[] {
   return Object.values(Countries);
}
